export default interface IConfigurationModel {
    bagsize: string | null
    body: string | null
    edge: string | null
    thread: string | null
    inside: string | null
    pocket: string | null
    side: string | null
    front: string | null
    tack: string | null
    back: string | null
    namechar: string | null
    namethread: string | null
    noName: string | null
}

export class ConfigurationModel implements IConfigurationModel {
    bagsize: string | null = null
    body: string | null = null
    edge: string | null = null
    thread: string | null = null
    inside: string | null = null
    pocket: string | null = null
    side: string | null = null
    front: string | null = null
    tack: string | null = null
    back: string | null = null
    namechar: string | null = null
    namethread: string | null = null
    noName: string | null = null

    constructor() {

    }
}

